import { refreshCsrfToken } from './refresh-csrf-token';

export default class ApplyForm {
    /*
     *
     *
     *
     *
     *	OLD PAYMENT FORM !!!
     *
     *
     *
     *
     *
     *
     */
    constructor(formElementID) {
        this.formElement = document.getElementById(formElementID);
        this.applyFormToPage();
    }

    applyFormToPage() {
        let emailInput = this.textInput('email', 'Электронная почта');
        let nameInput = this.textInput('name', 'ФИО');
        let phoneInput = this.textInput('phone', 'Номер телефона');
        let paymentInput = this.radioButtonInput('payment',
            [{
                    name: 'yookassa',
                    label: "Оплата по России через ЮКассу (Картой, Qiwi, ЮMoney)",
                    checked: true
                },
                {
                    name: 'other',
                    label: "Другим методом (Пишите на tsvetkova108@gmail.com)",
                    checked: false
                },
            ]);
        let termOfUse = this.chexkboxTermsOfUse('terms-of-use',
            "Я принимаю условия <a target='_blank' href='/terms-of-use'>Пользовательского соглашения</a>.");
        let sabmitBtn = this.submitButton('Зарегистрироваться');

    }

    textInput(title, placeholder) {
        let inputbox = document.createElement("div");
        inputbox.classList.add("inputbox");
        let inputdiv = document.createElement("div");
        inputdiv.classList.add("inputbox__input");
        let input = document.createElement("input");
        if (title === 'phone') {
            input.type = 'tel';
        } else if (title === 'email') {
            input.type = 'email';
        } else {
            input.type = 'text';
        }
        input.name = title;
        input.id = title;
        input.value = '';
        input.placeholder = " ";

        let label = document.createElement("label");
        label.classList.add("inputbox__label");
        label.setAttribute("for", title);
        label.innerHTML = placeholder;
        inputdiv.append(input);
        inputdiv.append(label);
        inputbox.append(inputdiv);
        this.formElement.append(inputbox);
        return input;
    }

    radioButtonInput(id, buttons) {
        let inputbox = document.createElement("div");
        inputbox.classList.add("inputbox");

        buttons.map(item => {
            let inputrow = document.createElement("div");
            inputrow.classList.add("inputrow");
            let label = document.createElement("label");
            label.classList.add("radioButton");
            label.setAttribute("for", item.name);
            let input = document.createElement("input");
            input.type = 'radio';
            input.name = id;
            input.value = item.name;
            input.checked = item.checked;
            let checkmark = document.createElement("span");
            checkmark.classList.add("checkmark");
            label.append(input);
            label.append(checkmark);
            label.append(item.label);
            label.addEventListener('click', this.onRadioButtonCheck);
            inputrow.append(label);
            inputbox.append(inputrow);
        });

        this.formElement.append(inputbox);
    }

    onRadioButtonCheck(e) {
        let input = null;
        if (e.target && e.target.classList && e.target.classList.contains('checkmark')) {
            if (e.target.parentElement && e.target.parentElement.firstElementChild) {
                input = e.target.parentElement.firstElementChild;
            }
        } else {
            if (e.target && e.target.firstElementChild) {
                input = e.target.firstElementChild;
            }
        }
        if (input !== null) {
            document.querySelectorAll(`input[name=${input.name}]`).forEach(item => {
                if (item) {
                    item.checked = (item.value === input.value);
                }
            })
        }
    }

    chexkboxTermsOfUse(id, text) {
        let inputrow = document.createElement("div");
        inputrow.classList.add("inputrow");
        let label = document.createElement("label");
        label.classList.add("inputrow__label-checkbox");
        label.setAttribute("for", id);
        let input = document.createElement("input");
        input.classList.add("chart-checkbox");
        input.type = 'checkbox';
        input.id = id;
        input.value = 'term-of-use';
        input.checked = false;
        let span = document.createElement("span");
        span.classList.add("checkbox");
        let textEl = document.createElement("span");
        textEl.classList.add("inputrow__text-checkbox");
        textEl.innerHTML = text;

        input.addEventListener("change", function (e) {
            //e.preventDefault();
            //e.target.checked = !e.target.checked;
            if (e.target && e.target.parentElement && e.target.parentElement.parentElement && e.target.parentElement.parentElement.parentElement) {
                let form = e.target.parentElement.parentElement.parentElement;
                let submit = form.querySelector('.form-submit-btn');
                if (submit) {
                    if (!e.target.checked) {
                        submit.setAttribute("disabled", null);
                    } else {
                        submit.removeAttribute("disabled");
                    }
                }
            }
        });

        label.append(input);
        label.append(span);
        label.append(textEl);
        inputrow.append(label);

        this.formElement.append(inputrow);
        return input;
    }

    submitButton(title) {
        let inputbox = document.createElement("div");
        inputbox.classList.add("inputbox");
        let button = document.createElement("button");
        button.innerHTML = "<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true' style='display:none'></span> " + title;
        button.classList.add("form-submit-btn", "btn", "btn-dark");
        button.setAttribute("disabled", null);
        button.addEventListener('click', this.onSendForm);
        inputbox.append(button);

        this.formElement.append(inputbox);
    }


    /**
     * Send form data to server
     * @param {Object} formData - Form data to send
     * @param {HTMLElement} spinnerDiv - Element to show status messages
     * @param {HTMLElement} btn - Submit button element
     * @param {HTMLElement} form - Form element
     * @param {boolean} retry - Whether this is a retry after CSRF token refresh
     */
    sendFormData(formData, spinnerDiv, btn, form, retry = false) {
        fetch('https://tsvetvaly.ru/ajaxpost', {
            method: "POST",
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': formData._token
            },
            credentials: 'same-origin'
        })
        .then(response => {
            // Check if response is ok (status 200-299)
            if (!response.ok) {
                // Handle 419 CSRF token mismatch
                if (response.status === 419 && !retry) {
                    // Try to refresh CSRF token and retry
                    return refreshCsrfToken(form)
                        .then(result => {
                            if (result.success && result.token) {
                                // Update token in formData
                                formData._token = result.token;
                                // Retry the request
                                return this.sendFormData(formData, spinnerDiv, btn, form, true);
                            } else {
                                throw new Error('Не удалось обновить токен безопасности. Пожалуйста, обновите страницу и попробуйте снова.');
                            }
                        });
                }
                
                // For other errors, try to parse JSON error message
                return response.json()
                    .then(errorData => {
                        const errorMessage = errorData.message || errorData.error || `Ошибка сервера (код ${response.status})`;
                        throw new Error(errorMessage);
                    })
                    .catch(() => {
                        // If JSON parsing fails, use status text
                        throw new Error(`Ошибка сервера: ${response.status} ${response.statusText}`);
                    });
            }
            
            // Response is ok, parse JSON
            return response.json();
        })
        .then(data => {
            if (data && data.success) {
                spinnerDiv.innerHTML = '<p style="color:green">Данные успешно отправлены!</p>';
                if (data.payment === 'yookassa') {
                    const yookassaDiv = document.getElementById("js-show-ykassa");
                    if (yookassaDiv) {
                        yookassaDiv.style.display = "block";
                    }
                    const custNameInput = document.querySelector('[name="custName"]');
                    if (custNameInput) {
                        custNameInput.value = data.name;
                    }
                }
            } else {
                const errorMessage = data?.message || data?.error || 'Произошла ошибка при отправке данных';
                spinnerDiv.innerHTML = `<p style="color:red">${errorMessage}</p>`;
                // Show button again so user can retry
                if (btn) {
                    btn.style.display = "";
                }
            }
        })
        .catch(error => {
            console.error('Error sending form:', error);
            const errorMessage = error.message || 'Произошла ошибка при отправке данных. Проверьте подключение к интернету и попробуйте снова.';
            spinnerDiv.innerHTML = `<p style="color:red">${errorMessage}</p>`;
            // Show button again so user can retry
            if (btn) {
                btn.style.display = "";
            }
        });
    }

    onSendForm(e) {
        e.preventDefault();
        let btn = e.target;
        let spinnerDiv = btn.parentElement;
        let form = btn.parentElement.parentElement;
        let course = document.getElementById('js-course-title').innerText;

        let formData = {
            _token: form.querySelector("input[name=_token]").value,
            course: course,
            email: form.querySelector("#email").value,
            name: form.querySelector("#name").value,
            phone: form.querySelector("#phone").value,
            payment: form.querySelector(`input[name=payment]:checked`).value,
			termsofuse: form.querySelector(`#terms-of-use`).checked,
        }

        for (var key in formData) {
            if (formData[key].length < 2) {
                alert('Все поля формы должны быть заполнены!');
                return false;
            }
        }

        btn.style.display = "none";
        spinnerDiv.innerHTML = '<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Ожидание ответа...</span></div>';

        // Send form data
        this.sendFormData(formData, spinnerDiv, btn, form);
    }

}
